import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 bg-white" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-101">
            Contact Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-102">
            Get In Touch
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-103">
          {/* Contact Info */}
          <div className="space-y-8" data-id="element-104">
            <div className="flex items-start gap-4" data-id="element-105">
              <div className="bg-accent p-4 rounded-full" data-id="element-106">
                <MapPinIcon className="w-6 h-6 text-primary" data-id="element-107" />
              </div>
              <div data-id="element-108">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-109">
                  Headquarters
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-110">
                  123 Towing Blvd
                  <br data-id="element-111" />
                  Alexandria, VA 22314
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-112">
              <div className="bg-accent p-4 rounded-full" data-id="element-113">
                <PhoneIcon className="w-6 h-6 text-primary" data-id="element-114" />
              </div>
              <div data-id="element-115">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-116">
                  Dispatch Center
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-117">
                  718.210.3110
                  <br data-id="element-118" />
                  <span className="text-sm text-gray-500" data-id="element-119">Available 24/7</span>
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-120">
              <div className="bg-accent p-4 rounded-full" data-id="element-121">
                <MailIcon className="w-6 h-6 text-primary" data-id="element-122" />
              </div>
              <div data-id="element-123">
                <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-124">Email</h3>
                <p className="text-gray-600 text-lg" data-id="element-125">
                  support@uzomatowing.com
                  <br data-id="element-126" />
                  <span className="text-sm text-gray-500" data-id="element-127">
                    We reply within 24 hours
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="bg-accent rounded-[10px] p-8 shadow-sm" data-id="element-128">
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-129">
              <div data-id="element-130">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-131">
                  Name
                </label>
                <input type="text" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="Your Name" data-id="element-132" />
              </div>
              <div data-id="element-133">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-134">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="you@example.com" data-id="element-135" />
              </div>
              <div data-id="element-136">
                <label className="block text-sm font-bold text-secondary mb-1" data-id="element-137">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="How can we help?" data-id="element-138"></textarea>
              </div>
              <button className="w-full bg-secondary hover:bg-blue-900 text-white font-bold py-4 rounded-[10px] transition-colors" data-id="element-139">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}